<template>
  <div @click="screen">
    <el-tooltip  :content="fullscreen?'取消全屏':'全屏'" effect="dark" placement="bottom">
      <!-- <i class="el-icon-full-screen" style="font-size: 22px"></i>-->
      <span class="icon iconfont" style="font-size: 22px">&#xec13;</span>
    </el-tooltip>
  </div>
</template>

<script>

  export default {
    name: 'screenfull',
    data() {
      return {
        fullscreen: false
      }
    },
    created(){
      //监听各浏览器fullscreenchange 事件处理
      document.addEventListener('fullscreenchange', () => {
        this.fullscreen=!this.fullscreen
      });
      document.addEventListener('mozfullscreenchange', () => {
        this.fullscreen=!this.fullscreen
      });
      document.addEventListener('webkitfullscreenchange', () => {
        this.fullscreen=!this.fullscreen
      });
      document.addEventListener('msfullscreenchange', () => {
        this.fullscreen=!this.fullscreen
      });
    },
    methods: {
      screen() {
        let element = document.documentElement;
        //取消全屏
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          //全屏
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
       // this.fullscreen = !this.fullscreen;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/screenfull/index.vue